import axios from "axios";
import { apiUrl } from "../../config";

export const addJob = (acc) => async (dispatch) => {
  console.log("ACTION------>", acc);
  dispatch({ type: "ADD_JOB_REQUEST" });
  try {
    const response = await axios.post(`${apiUrl}/api/job/create`, acc);
    console.log("+++ add", response);
    dispatch({ type: "ADD_JOB_SUCCESS" });
    return {
      response,
    };
  } catch (error) {
    dispatch({ type: "ADD_JOB_FAILED", payload: error });
  }
};

export const allJobClear = (acc) => async (dispatch) => {
  try {
    dispatch({ type: "ALL_JOB_CLEAR" });
  } catch (error) {
    dispatch({ type: "ALL_JOB_FAILED", payload: error });
  }
};

export const getAllJobLength = () => async (dispatch) => {
  try {
    const response = await axios.get(`${apiUrl}/api/job/getalljob_length`);
    //console.log('%%%111%%%',response.data.results[0].tot);
    return { response };
  } catch (error) {}
};

export const getAllJobbycus =
  (offset, row_count, cus_name, phone, from_date) => async (dispatch) => {
    console.log("GGGGGGG", from_date);
    dispatch({ type: "GET_JOB_REQUEST" });

    try {
      const response = await axios.get(
        `${apiUrl}/api/job/getalljobbycus/${offset}/${row_count}/${cus_name}/${phone}/${from_date}`
      );
      console.log("%%%%%%", response);
      dispatch({ type: "GET_JOB_SUCCESS", payload: response.data.results });
    } catch (error) {
      console.log("EEEEEEEE", error);
      dispatch({ type: "GET_JOB_FAILED", payload: error });
    }
  };

export const getAllJob = (offset, row_count) => async (dispatch) => {
  dispatch({ type: "GET_JOB_REQUEST" });

  try {
    const response = await axios.get(
      `${apiUrl}/api/job/getalljob/${offset}/${row_count}`
    );
    //console.log('%%%%%%',response);
    dispatch({ type: "GET_JOB_SUCCESS", payload: response.data.results });
  } catch (error) {
    console.log("EEEEEEEE", error);
    dispatch({ type: "GET_JOB_FAILED", payload: error });
  }
};

export const updateJob = (pur) => async (dispatch) => {
  try {
    const response = await axios.post(`${apiUrl}/api/job/update`, pur);
    return { response };
    // window.location.reload()
  } catch (error) {
    alert("Something Went Wrong");
    console.log(error);
  }
};

export const updateJobStatus = (pur) => async (dispatch) => {
  try {
    const response = await axios.post(`${apiUrl}/api/job/updateJobStatus`, pur);
    return { response };
    // window.location.reload()
  } catch (error) {
    alert("Something Went Wrong");
    console.log(error);
  }
};

export const deleteJob = (accid) => async (dispatch) => {
  try {
    const response = await axios.post(`${apiUrl}/api/job/delete`, { accid });
    return { response };
    // window.location.reload()
  } catch (error) {
    alert("Something Went Wrong");
    console.log(error);
  }
};

export const getBill = (id, cus_name) => async (dispatch) => {
  dispatch({ type: "GET_JOB_REQUEST" });

  try {
    const response = await axios.get(
      `${apiUrl}/api/job/getbill/${id}/${cus_name}`
    );
    console.log("%%%%%%", response);
    dispatch({ type: "GET_JOB_SUCCESS", payload: response.data.results });
  } catch (error) {
    dispatch({ type: "GET_JOB_FAILED", payload: error });
  }
};

export const searchJob = (val) => async (dispatch) => {
  const data = { id: val };
  try {
    const response = await axios.post(`${apiUrl}/api/job/search`, data);
    return { response };
    // window.location.reload()
  } catch (error) {
    return { error };
    //alert('Something Went Wrong')
    console.log(error);
  }
};

export const filterJob = (data) => async (dispatch) => {
  try {
    const response = await axios.post(`${apiUrl}/api/job/filterdate`, data);
    return { response };
    // window.location.reload()
  } catch (error) {
    return { error };
    //alert('Something Went Wrong')
    console.log(error);
  }
};

export const CheckedBillJob = (id, val) => async (dispatch) => {
  const data = { id, val };
  try {
    const response = await axios.post(`${apiUrl}/api/job/checked`, data);
    return { response };
    // window.location.reload()
  } catch (error) {
    return { error };
    //alert('Something Went Wrong')
    console.log(error);
  }
};
